import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import StepFinish from "./Steps/StepFinish";

const MobileAppSteps = ({ step }) => {

    switch (step) {
        case '1':
            return <Step1 />
        case '2':
            return <Step2 />
        case '3':
            return <Step3 />
        case '4':
            return <Step4 />
        case 'done':
            return <StepFinish />
    }

    return null

}
export default MobileAppSteps;
